import React from "react";
import { Link } from "react-router-dom";
import "./Admin.css";

export default function AdminHome() {
  return (
    <div className="admin-container" style={{ marginLeft: "var(--admin-sidebar-layout-width)", paddingTop: 24 }}>
      <h1 className="admin-title">Welcome, Admin</h1>

      <div style={{ display: "flex", gap: 20, marginTop: 18 }}>
        <Link to="/portal-admin/dashboard" className="admin-link-btn">View Platform Overview</Link>
        <Link to="/portal-admin/clients" className="admin-link-btn">Manage Clients</Link>
      </div>

      <div style={{ marginTop: 24 }}>
        <p>Use the admin workspace to review platform-wide KPIs, manage clients, and jump into the client view when needed.</p>
      </div>
    </div>
  );
}
